export default __webpack_public_path__ + "static/media/updapt-logo-white.fdc223ca.png";